module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"vacancies":"Вакансии"}}')
  delete Component.options._Ctor
}
